<template>
<!-- 项目大屏配置 -->
    <div class="config-box">
        <div class="box-main">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="3*2大屏" name="first">
                    <div style="width:100%;height:6vh;position: relative;display:flex;">
                        <p style="width:15%;text-align: center;">适配（像素）</p>
                        <p style="width:20%;text-align: center;">名称</p>
                        <p style="width:15%;text-align: center;">间距（像素）</p>
                        <p style="width:25%;text-align: center;">边框</p>
                        <p style="width:25%;text-align: center;">状态</p>
                    </div>
                    <ul>
                        <li v-for="(item,index) in dataList32" :key="index" style="width:100%;height:6vh;display:flex;">
                            <p style="width:15%;text-align: center;">{{item.width}}</p>
                            <p style="width:20%;text-align: center;">{{item.name}}</p>
                            <p style="width:15%;text-align: center;">
                                <el-input v-model="item.margin" type="number" placeholder=""></el-input>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.border">
                                    <el-radio :label="false">隐藏</el-radio>
                                    <el-radio :label="true">显示</el-radio>
                                </el-radio-group>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.show">
                                    <el-radio :label="true">开启</el-radio>
                                    <el-radio :label="false">关闭</el-radio>
                                </el-radio-group>
                            </p>
                        </li>
                    </ul>
                    <div style="margin-top:3vh;text-align: center;">
                        <!-- <el-button @click="ctrlVis = false" style="margin-right:2vh;">取 消</el-button> -->
                        <el-button @click="refreshCtl32">确 定</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="3*3大屏" name="second">
                    <div style="width:100%;height:6vh;position: relative;display:flex;">
                        <p style="width:15%;text-align: center;">适配（像素）</p>
                        <p style="width:20%;text-align: center;">名称</p>
                        <p style="width:15%;text-align: center;">间距（像素）</p>
                        <p style="width:25%;text-align: center;">边框</p>
                        <p style="width:25%;text-align: center;">状态</p>
                    </div>
                    <ul>
                        <li v-for="(item,index) in dataList33" :key="index" style="width:100%;height:6vh;display:flex;">
                            <p style="width:15%;text-align: center;">{{item.width}}</p>
                            <p style="width:20%;text-align: center;">{{item.name}}</p>
                            <p style="width:15%;text-align: center;">
                                <el-input v-model="item.margin" type="number" placeholder=""></el-input>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.border">
                                    <el-radio :label="false">隐藏</el-radio>
                                    <el-radio :label="true">显示</el-radio>
                                </el-radio-group>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.show">
                                    <el-radio :label="true">开启</el-radio>
                                    <el-radio :label="false">关闭</el-radio>
                                </el-radio-group>
                            </p>
                        </li>
                    </ul>
                    <div style="margin-top:3vh;text-align: center;">
                        <!-- <el-button @click="ctrlVis = false" style="margin-right:2vh;">取 消</el-button> -->
                        <el-button @click="refreshCtl33">确 定</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="3*4大屏" name="third">
                    <div style="width:100%;height:6vh;position: relative;display:flex;">
                        <p style="width:15%;text-align: center;">适配（像素）</p>
                        <p style="width:20%;text-align: center;">名称</p>
                        <p style="width:15%;text-align: center;">间距（像素）</p>
                        <p style="width:25%;text-align: center;">边框</p>
                        <p style="width:25%;text-align: center;">状态</p>
                    </div>
                    <ul>
                        <li v-for="(item,index) in dataList34" :key="index" style="width:100%;height:6vh;display:flex;">
                            <p style="width:15%;text-align: center;">{{item.width}}</p>
                            <p style="width:20%;text-align: center;">{{item.name}}</p>
                            <p style="width:15%;text-align: center;">
                                <el-input v-model="item.margin" type="number" placeholder=""></el-input>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.border">
                                    <el-radio :label="false">隐藏</el-radio>
                                    <el-radio :label="true">显示</el-radio>
                                </el-radio-group>
                            </p>
                            <p style="width:25%;text-align: center;">
                                <el-radio-group v-model="item.show">
                                    <el-radio :label="true">开启</el-radio>
                                    <el-radio :label="false">关闭</el-radio>
                                </el-radio-group>
                            </p>
                        </li>
                    </ul>
                    <div style="margin-top:3vh;text-align: center;">
                        <!-- <el-button @click="ctrlVis = false" style="margin-right:2vh;">取 消</el-button> -->
                        <el-button @click="refreshCtl34">确 定</el-button>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        return{
            activeName:'first',
            groupId:'',
            port:'',
            dataList32:[
                {name:'今日出勤',index:"1",order:0,margin:20,show:true,width:860,border:false},
                {name:'在场人员',index:"2",order:1,margin:20,show:true,width:860,border:false},
                {name:'人员动态',index:"3",order:2,margin:20,show:true,width:860,border:false},
                {name:'班组出勤',index:"4",order:3,margin:20,show:true,width:860,border:false},
                {name:'合同信息',index:"5",order:4,margin:20,show:true,width:860,border:false},
                {name:'质量安全',index:"6",margin:0,show:true,width:860,border:true},
                {name:'疫情管控',index:"7",margin:20,show:true,width:860,border:true},
                {name:'车辆统计',index:"8",margin:20,show:true,width:860,border:true},
                {name:'能耗统计',index:"9",margin:0,show:true,width:1400,border:true},
                {name:'塔吊监测',index:"10",margin:0,show:true,width:1400,border:true},
                {name:'扬尘监测',index:"11",margin:0,show:true,width:1400,border:true},
                {name:'进出口实时人脸考勤',index:"12",margin:0,show:true,width:1400,border:true},
                {name:'设备运行监测',index:"13",margin:0,show:true,width:1400,border:true},
                {name:'监控预警',index:"14",margin:0,show:true,width:1400,border:true},
                {name:'安康码管控系统',index:"15",margin:0,show:true,width:1400,border:true},
                {name:'升降机监测',index:"16",margin:0,show:true,width:1400,border:true},
                {name:'BIM交互管理',index:"17",margin:0,show:true,width:1400,border:true},
                {name:'高支模监测',index:"18",margin:0,show:true,width:860,border:true},
                {name:'混凝土测温',index:"19",margin:20,show:true,width:860,border:true},
                {name:'BIM',index:"20",margin:20,show:true,width:860,border:true},
                {name:'卸料平台',index:"21",order:2,margin:20,show:true,width:1400,border:true},
                {name:'螺帽监测',index:"22",order:2,margin:20,show:false,width:860,border:true},
            ],
            dataList33:[
                {name:'今日出勤',index:"1",order:0,margin:20,show:true,width:860,border:false},
                {name:'在场人员',index:"2",order:1,margin:20,show:true,width:860,border:false},
                {name:'人员动态',index:"3",order:2,margin:20,show:true,width:860,border:false},
                {name:'班组出勤',index:"4",order:3,margin:20,show:true,width:860,border:false},
                {name:'合同信息',index:"5",order:4,margin:20,show:true,width:860,border:false},
                {name:'质量安全',index:"6",margin:0,show:true,width:860,border:true},
                {name:'疫情管控',index:"7",margin:20,show:true,width:860,border:true},
                {name:'车辆统计',index:"8",margin:20,show:true,width:860,border:true},
                {name:'能耗统计',index:"9",margin:0,show:true,width:1400,border:true},
                {name:'塔吊监测',index:"10",margin:0,show:true,width:1400,border:true},
                {name:'扬尘监测',index:"11",margin:0,show:true,width:1400,border:true},
                {name:'进出口实时人脸考勤',index:"12",margin:0,show:true,width:1400,border:true},
                {name:'设备运行监测',index:"13",margin:0,show:true,width:1400,border:true},
                {name:'监控预警',index:"14",margin:0,show:true,width:1400,border:true},
                {name:'安康码管控系统',index:"15",margin:0,show:true,width:1400,border:true},
                {name:'升降机监测',index:"16",margin:0,show:true,width:1400,border:true},
                {name:'BIM交互管理',index:"17",margin:0,show:true,width:1400,border:true},
                {name:'高支模监测',index:"18",margin:0,show:true,width:860,border:true},
                {name:'混凝土测温',index:"19",margin:20,show:true,width:860,border:true},
                {name:'BIM',index:"20",margin:20,show:true,width:860,border:true},
                {name:'卸料平台',index:"21",order:2,margin:20,show:true,width:1400,border:true},
                {name:'螺帽监测',index:"22",order:2,margin:20,show:false,width:860,border:true},
            ],
            dataList34:[
                {name:'今日出勤',index:"1",order:0,margin:20,show:true,width:860,border:false},
                {name:'在场人员',index:"2",order:1,margin:20,show:true,width:860,border:false},
                {name:'人员动态',index:"3",order:2,margin:20,show:true,width:860,border:false},
                {name:'班组出勤',index:"4",order:3,margin:20,show:true,width:860,border:false},
                {name:'合同信息',index:"5",order:4,margin:20,show:true,width:860,border:false},
                {name:'质量安全',index:"6",margin:0,show:true,width:860,border:true},
                {name:'疫情管控',index:"7",margin:20,show:true,width:860,border:true},
                {name:'车辆统计',index:"8",margin:20,show:true,width:860,border:true},
                {name:'能耗统计',index:"9",margin:0,show:true,width:1400,border:true},
                {name:'塔吊监测',index:"10",margin:0,show:true,width:1400,border:true},
                {name:'扬尘监测',index:"11",margin:0,show:true,width:1400,border:true},
                {name:'进出口实时人脸考勤',index:"12",margin:0,show:true,width:1400,border:true},
                {name:'设备运行监测',index:"13",margin:0,show:true,width:1400,border:true},
                {name:'监控预警',index:"14",margin:0,show:true,width:1400,border:true},
                {name:'安康码管控系统',index:"15",margin:0,show:true,width:1400,border:true},
                {name:'升降机监测',index:"16",margin:0,show:true,width:1400,border:true},
                {name:'BIM交互管理',index:"17",margin:0,show:true,width:1400,border:true},
                {name:'高支模监测',index:"18",margin:0,show:true,width:860,border:true},
                {name:'混凝土测温',index:"19",margin:20,show:true,width:860,border:true},
                {name:'BIM',index:"20",margin:20,show:true,width:860,border:true},
                {name:'卸料平台',index:"21",order:2,margin:20,show:true,width:1400,border:true},
                {name:'螺帽监测',index:"22",order:2,margin:20,show:false,width:860,border:true},
            ],
            onlineData32:[  //线上数据

            ],
            onlineData33:[  //线上数据

            ],
            onlineData34:[  //线上数据

            ],
            id32:'',
            id33:'',
            id34:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData() //3*2
    },
    methods:{
        getData(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'1'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        that.id32 = data.id
                        that.onlineData32 = list
                        for(var i=0;i<that.dataList32.length;i++){
                            var obj = that.sysFun(that.dataList32[i],list)
                            that.dataList32[i].margin = obj.margin
                            that.dataList32[i].show = obj.show
                            that.dataList32[i].border = obj.border
                        }
                    }
                }
            })
        },

        //切换tab
        handleClick(e){
            if(e.index==0){
                this.getData()
            }else if(e.index==1){
                this.getData33()
            }else if(e.index==2){
                this.getData34()
            }
        },

        getData33(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        that.id33 = data.id
                        that.onlineData33 = list
                        for(var i=0;i<that.dataList33.length;i++){
                            var obj = that.sysFun(that.dataList33[i],list)
                            that.dataList33[i].margin = obj.margin
                            that.dataList33[i].show = obj.show
                            that.dataList33[i].border = obj.border
                        }
                    }
                }
            })
        },

        getData34(){
            var that = this
            myHttp.selectHomePage({
                groupId:this.groupId,
                type:'3'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.HomePage
                    if(data){
                        var list = JSON.parse(data.numerical)
                        that.id34 = data.id
                        that.onlineData34 = list
                        for(var i=0;i<that.dataList34.length;i++){
                            var obj = that.sysFun(that.dataList34[i],list)
                            that.dataList34[i].margin = obj.margin
                            that.dataList34[i].show = obj.show
                            that.dataList34[i].border = obj.border
                        }
                        
                    }
                }
            })
        },

        //同步后台数据
        sysFun(obj,list){
            var result = {margin:0,show:true,border:true}
            for(var i=0;i<list.length;i++){
                for(var j=0;j<list[i].length;j++){
                    if(obj.index==list[i][j].index){
                        result = list[i][j]
                    }
                }
            }
            return result
        },

        //保存3*2
        refreshCtl32(){
            var list = this.onlineData32
            for(var i=0;i<list.length;i++){
                for(var j=0;j<list[i].length;j++){
                    list[i][j] = this.getNewData(list[i][j],this.dataList32)
                }
            }
            var that = this
            if(this.id32 && this.id32!=''){
                myHttp.updateHomePage({
                    id:this.id32,
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'1'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*2大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'1'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*2大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }

        },
        //保存时获取最新数据
        getNewData(obj,list){
            for(var i=0;i<list.length;i++){
                if(obj.index==list[i].index){
                    obj = list[i]
                }
            }
            return obj
        },
        //保存3*3
        refreshCtl33(){
            var list = this.onlineData33
            for(var i=0;i<list.length;i++){
                for(var j=0;j<list[i].length;j++){
                    list[i][j] = this.getNewData(list[i][j],this.dataList33)
                }
            }
            var that = this
            if(!this.id33 || this.id33==''){
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'2'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*3大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{
                myHttp.updateHomePage({
                    id:this.id33,
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'2'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*3大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }

        },
        //保存3*4
        refreshCtl34(){
            var list = this.onlineData34
            for(var i=0;i<list.length;i++){
                for(var j=0;j<list[i].length;j++){
                    list[i][j] = this.getNewData(list[i][j],this.dataList34)
                }
            }
            var that = this
            if(this.id34 && this.id34!=''){
                myHttp.updateHomePage({
                    id:this.id34,
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'3'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*2大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }else{
                myHttp.postHomePage({
                    groupId:this.groupId,
                    numerical:JSON.stringify(list),
                    type:'3'
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('3*2大屏保存成功');
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){
                    that.$message.error('服务器繁忙，请稍后再试');
                })
            }

        },

    }
}
</script>

<style scoped>
    .config-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-main{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
        background: #fff;
    }
</style>

<style>
    .config-box .el-tabs__content{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
    }
    .config-box .el-tab-pane{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: auto;
    }
</style>